import Navbar2 from "../Components/Navbar2";
import Footer from "../Components/Footer";

function VolleyballTourneys() {
  return(
      <>
      <Navbar2 />
      <div className="container-fluid px-0 pb-4 pt-5">
      <div className='h1 text-center'>
        USAV TOURNAMENTS <br/>hosted by ADS Sports Complex
      </div>
          <div className="h4 ms-5 me-5 pb-3 fw-light">
            Get ready for another action-packed season of elite volleyball
            competition at the ADS Sports Complex! From high-energy VolleyFests
            to our exciting Developmental Series, there’s something for every
            age group and skill level. Don’t miss your chance to compete,
            grow, and experience volleyball at its best!
          </div>
        {/* USAV Tournaments */}
        <div className="container my-5">
            <div className="table-responsive">
              <table className="table table-bordered text-start align-middle">
                <thead className="table-success">
                  <tr>
                    <th scope="col">Date</th>
                    <th scope="col">Tournament</th>
                    <th scope="col">Location</th>
                    <th scope="col">Tourney Fee</th>
                    <th scope="col">Age Divisions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>12/6/2025</td>
                    <td>
                      <a href="https://www.advancedeventsystems.com/42334"
                        target="_blank" rel="noreferrer">
                        ADS VolleyFest #1
                      </a>
                    </td>
                    <td>
                      <a href="https://maps.app.goo.gl/ezeA7H5vzSeZQfEx5"
                        target="_blank" rel="norferrer noreferrer">
                        ADS Sports Complex
                      </a>
                    </td>
                    <td>$160</td>
                    <td>17, 18</td>
                  </tr>
                  <tr>
                    <td>12/13/2025</td>
                    <td>
                      <a href="https://www.advancedeventsystems.com/42335"
                        target="_blank" rel="noreferrer">
                        ADS VolleyFest #2
                      </a>
                    </td>
                    <td><a href="https://maps.app.goo.gl/ezeA7H5vzSeZQfEx5"
                      target="_blank" rel="norferrer noreferrer">
                        ADS Sports Complex
                      </a>
                    </td>
                    <td>$160</td>
                    <td>10, 11, 12</td>
                  </tr>
                  <tr>
                    <td>12/20/2025</td>
                    <td>
                      <a href="https://www.advancedeventsystems.com/42336"
                        target="_blank" rel="noreferrer">
                        ADS VolleyFest #3
                      </a>
                    </td>
                    <td><a href="https://maps.app.goo.gl/ezeA7H5vzSeZQfEx5"
                      target="_blank" rel="norferrer noreferrer">
                        ADS Sports Complex
                      </a>
                    </td>
                    <td>$230</td>
                    <td>17, 18</td>
                  </tr>
                  <tr>
                    <td>1/04/2026</td>
                    <td>
                      <a href="https://www.advancedeventsystems.com/42338"
                        target="_blank" rel="noreferrer">
                        ADS Volleyball Developmental #1 
                      </a>
                    </td>
                    <td><a href="https://maps.app.goo.gl/ezeA7H5vzSeZQfEx5"
                      target="_blank" rel="norferrer noreferrer">
                        ADS Sports Complex
                      </a>
                    </td>
                    <td>$145</td>
                    <td>6-7, 8-9, 10, 11, &amp; 12</td>
                  </tr>
                  <tr>
                    <td>1/17/2026</td>
                    <td>
                      <a href="https://www.advancedeventsystems.com/42340"
                        target="_blank" rel="noreferrer">
                        ADS VolleyFest #4
                      </a>
                    </td>
                    <td><a href="https://maps.app.goo.gl/ezeA7H5vzSeZQfEx5"
                      target="_blank" rel="norferrer noreferrer">
                        ADS Sports Complex
                      </a>
                    </td>
                    <td>$230</td>
                    <td>11, 12</td>
                  </tr>
                  <tr>
                    <td>1/17/2026</td>
                    <td>
                      <a href="https://www.advancedeventsystems.com/42340"
                        target="_blank" rel="noreferrer">
                        ADS Volleyball Developmental #2
                      </a>
                    </td>
                    <td><a href="https://maps.app.goo.gl/ezeA7H5vzSeZQfEx5"
                      target="_blank" rel="norferrer noreferrer">
                        ADS Sports Complex
                      </a>
                    </td>
                    <td>$145</td>
                    <td>6-7, 8-9, 10, 11, &amp; 12</td>
                  </tr>
                  <tr>
                    <td>1/24/2026</td>
                    <td>
                      <a href="https://www.advancedeventsystems.com/42343"
                        target="_blank" rel="noreferrer">
                        ADS Volleyball Developmental #3
                      </a>
                    </td>
                    <td><a href="https://maps.app.goo.gl/ezeA7H5vzSeZQfEx5"
                      target="_blank" rel="norferrer noreferrer">
                        ADS Sports Complex
                      </a>
                    </td>
                    <td>$145</td>
                    <td>6-7, 8-9, 10, 11, &amp; 12</td>
                  </tr>
                  <tr>
                    <td>1/31/2026</td>
                    <td>
                      <a href="https://www.advancedeventsystems.com/42345"
                        target="_blank" rel="noreferrer">
                        ADS Volleyball Developmental #4
                      </a>
                    </td>
                    <td><a href="https://maps.app.goo.gl/ezeA7H5vzSeZQfEx5"
                      target="_blank" rel="norferrer noreferrer">
                        ADS Sports Complex
                      </a>
                    </td>
                    <td>$145</td>
                    <td>6-7, 8-9, 10, 11, &amp; 12</td>
                  </tr>
                  <tr>
                    <td>1/31/2026</td>
                    <td>
                      <a href="https://www.advancedeventsystems.com/42344"
                        target="_blank" rel="noreferrer">
                        ADS VolleyFest #5
                      </a>
                    </td>
                    <td><a href="https://maps.app.goo.gl/ezeA7H5vzSeZQfEx5"
                      target="_blank" rel="norferrer noreferrer">
                        ADS Sports Complex
                      </a>
                    </td>
                    <td>$230</td>
                    <td>16, 17, 18</td>
                  </tr>
                  <tr>
                    <td>2/07/2026</td>
                    <td>
                      <a href="https://www.advancedeventsystems.com/42346"
                        target="_blank" rel="noreferrer">
                        ADS Volleyball Developmental #5
                      </a>
                    </td>
                    <td><a href="https://maps.app.goo.gl/ezeA7H5vzSeZQfEx5"
                      target="_blank" rel="norferrer noreferrer">
                        ADS Sports Complex
                      </a>
                    </td>
                    <td>$145</td>
                    <td>6-7, 8-9, 10, 11, &amp; 12</td>
                  </tr>
                  <tr>
                    <td>2/21/2026</td>
                    <td>
                      <a href="https://www.advancedeventsystems.com/42347"
                        target="_blank" rel="noreferrer">
                        ADS Volleyball Developmental #6
                      </a>
                    </td>
                    <td><a href="https://maps.app.goo.gl/ezeA7H5vzSeZQfEx5"
                      target="_blank" rel="norferrer noreferrer">
                        ADS Sports Complex
                      </a>
                    </td>
                    <td>$145</td>
                    <td>6-7, 8-9, 10, 11, &amp; 12</td>
                  </tr>
                  <tr>
                    <td>3/07/2026</td>
                    <td>
                      <a href="https://www.advancedeventsystems.com/42351"
                        target="_blank" rel="noreferrer">
                        ADS Volleyball Developmental #7
                      </a>
                    </td>
                    <td><a href="https://maps.app.goo.gl/ezeA7H5vzSeZQfEx5"
                      target="_blank" rel="norferrer noreferrer">
                        ADS Sports Complex
                      </a>
                    </td>
                    <td>$145</td>
                    <td>6-7, 8-9, 10, 11, &amp; 12</td>
                  </tr>
                  <tr>
                    <td>3/14/2026</td>
                    <td>
                      <a href="https://www.advancedeventsystems.com/42352"
                        target="_blank" rel="noreferrer">
                        ADS Volleyball Developmental #8
                      </a>
                    </td>
                    <td><a href="https://maps.app.goo.gl/ezeA7H5vzSeZQfEx5"
                      target="_blank" rel="norferrer noreferrer">
                        ADS Sports Complex
                      </a>
                    </td>
                    <td>$145</td>
                    <td>6-7, 8-9, 10, 11, &amp; 12</td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>
    </div>
      <Footer />
      </>
  );
}

export default VolleyballTourneys;
